var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsApprovalActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82355 7.36707L11.9146 11.4954L21.0057 7.36707V18.4023C21.0057 18.8008 20.7691 19.1613 20.4035 19.3198L11.9146 23L3.42578 19.3198C3.06016 19.1613 2.82355 18.8008 2.82355 18.4023V7.36707Z",
    fill: "#383434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82355 7.36707L11.9146 11.4954M2.82355 7.36707V18.4023C2.82355 18.8008 3.06016 19.1613 3.42578 19.3198L11.9146 23M2.82355 7.36707L5.64708 5.91743M11.9146 11.4954L21.0057 7.36707M11.9146 11.4954V23M21.0057 7.36707V18.4023C21.0057 18.8008 20.7691 19.1613 20.4035 19.3198L11.9146 23M21.0057 7.36707L17.7329 5.91743",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1041 1.99999L10.9792 7.58674L7.99976 5.08822",
    stroke: "#ffffff",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsApprovalActive);
export default __webpack_public_path__ + "static/media/productsApprovalActive.e91d2933cf37f3a50917fafd216a0557.svg";
export { ForwardRef as ReactComponent };